import React from 'react';
import { CalendarDays, Clock3 } from 'lucide-react';
import './BatchTimings.css';

const BatchTimings = () => {
  return (
    <section className="batch-timing-section">
      <div className="batch-timing-container">
        <h2 className="batch-timing-title">Batch Timings & Format</h2>
        <p className="batch-timing-subtitle">
          Get details about our upcoming batches and flexible schedules.
        </p>

        <div className="batch-timing-cards">

          <div className="batch-timing-card">
            <div className="batch-timing-icon-box">
              <CalendarDays className="batch-timing-icon" />
            </div>
            <h3 className="batch-timing-label">Start Date</h3>
            <p className="batch-timing-detail">Monday, 16th September 2025</p>
          </div>

          <div className="batch-timing-card">
            <div className="batch-timing-icon-box">
              <Clock3 className="batch-timing-icon" />
            </div>
            <h3 className="batch-timing-label">Schedule</h3>
            <p className="batch-timing-detail">Monday to Friday<br />7:00 PM – 9:00 PM IST</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BatchTimings;
